import resume from '../assets/pdf/resume.pdf'
import madan from '../components/images/madan.png';

export const headerData = {
    name: "Madan Lal",
    title: "",
    desciption:(<>Greetings! I am Madan Lal, a Software Engineering graduate from <strong>Sukkur IBA University</strong> through the <strong>OGDCL National Talent Hunt Program</strong> scholarship. I present myself as a dedicated, motivated, and trustworthy individual, passionate about frontend development and CMS website design, with a strong eagerness to create better and more engaging websites.</>),
    image: madan,
    resumePdf: resume
}
